import React from 'react';

function UpgradeExperience({ setView }) {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    } else if (setView) {
      window.history.pushState({}, '', '/contact/');
      setView('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="upgrade-experience-section">
      {/* Dynamic gradient background */}
      <div className="upgrade-experience-bg"></div>
      
      <div className="container upgrade-experience-container">
        {/* Left Column: Text & CTA */}
        <div className="upgrade-experience-left">
          <h2 className="upgrade-experience-title">
            Ready to <span className="highlight-red-text">upgrade</span> your customer experience?
          </h2>
          
          <p className="upgrade-experience-desc">
            We rethink business growth for you through our collective experience with strategic partner ecosystem. Let’s discuss your next move.
          </p>
          
          <p className="upgrade-experience-desc">
            Our services maintain transparency with clients throughout the entire process. We’re your reliable and trustworthy partner for every digital service you need.
          </p>

          <button className="btn-schedule btn-upgrade-needs" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Mockup Image */}
        <div className="upgrade-experience-right">
          <img 
            src="/assets/images/aug_mob_img-1.webp" 
            alt="Customer Experience Mockup" 
            className="upgrade-experience-img"
          />
        </div>
      </div>
    </section>
  );
}

export default UpgradeExperience;
